import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { ProximamenteDlgComponent } from '@appNeo/pages/components/proximamente-dlg/proximamente-dlg.component';

import { PAGINAS_ROUTES } from '@appNeo/pages/pages-routes-data';
import { environment } from '@environments/environment';
import { finalize } from 'rxjs';

@Component({
  selector: 'neo-bottom-cta',
  templateUrl: './bottom-cta.component.html',
  styleUrls: ['./bottom-cta.component.scss']
})
export class BottomCtaComponent implements OnInit {

  @Input() pathReservar: string = '/' + PAGINAS_ROUTES.PAGINA_RESERVAR;
  @Input() pathFaqs: string = '/' + PAGINAS_ROUTES.PAGINA_FAQS;
  @Input() color: string  = 'color';
  @Input() queryParamsFaq: string = undefined;
  @ViewChildren(ProximamenteDlgComponent) accionesDialogoProximamente: QueryList<ProximamenteDlgComponent>;
  @Input() constanteComprobarAccion = ConstantesConfiguracionCalendarioEnum.AccesoAltaReservasPublico;
  constructor(
    private router: Router,
    private preferenciasService: PreferenciasService,
    private auxiliarService: AuxiliarService
  ) { }

  ngOnInit(): void {
  }
  accederReservar() {
    this.validarAccion();

    // if (environment.proximamente_reservas) {
    //   this.accionesDialogoProximamente.first.abrirDialogo();

    // } else {
    //   this.router.navigate([this.pathReservar]);
    // }
  }

  desencadenarAccion: boolean = !environment.proximamente_reservas;
  accion(data?: any) {
    if (this.desencadenarAccion) {
      this.router.navigate([this.pathReservar]);
    } else {
      this.mostrarProximamente();
    }
  }
  validarAccion(data?: any) {
    this.preferenciasService.getApi(this.constanteComprobarAccion, true)
      .pipe(
        finalize(() => {
          this.accion(data);
        })
      )
      .subscribe(
        x => this.desencadenarAccion = this.auxiliarService.getBoolean(x.valor),
        e => this.desencadenarAccion = this.auxiliarService.getBoolean(this.preferenciasService.get(this.constanteComprobarAccion))
      );
  }
  mostrarProximamente() {
    this.accionesDialogoProximamente.first.abrirDialogo();
  }
}
